export default {
    TutorialConfig: {
        // no key fields since TutorialConfig is a singleton
        // docs: https://www.apollographql.com/docs/react/caching/cache-configuration/
        keyFields: []
    }
}
